import { memo, useState } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { FixaQuantityStepper } from "@coworker/apprestructured/src/shared/wrappers/FixaQuantityStepper/FixaQuantityStepper";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import ListItemWithControls from "@coworker/apprestructured/src/task-management/components/ListItemWithControls/ListItemWithControls";

function ListItemWithControlsDemo() {
  const [title, setTitle] = useState("Media Item 1");
  const [description, setDescription] = useState("PALLET • 12345678");
  const [quantity, setQuantity] = useState(5);
  const [maxQuantity, setMaxQuantity] = useState(10);

  return (
    <Demo>
      <Name>ListItemWithControls</Name>
      <Highlight>
        <FixaListView id="list-item-controls-demo">
          <ListItemWithControls
            title={title}
            description={description}
            quantityLabel={
              <FixaText textStyle="Body.M">{maxQuantity} pieces</FixaText>
            }
          >
            <FixaQuantityStepper
              small
              fluid
              defaultValue={quantity}
              minVal={1}
              maxVal={maxQuantity}
              ariaDescribedBy="demo-stepper-1"
              ariaDescribedById="demo-stepper-1"
              onChange={(e) => setQuantity(parseInt(e.target.value, 10))}
            />
          </ListItemWithControls>
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaInputField
          label="Title"
          type="text"
          id="listitemwithcontrols-title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <FixaInputField
          label="Description"
          type="text"
          id="listitemwithcontrols-description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <FixaInputField
          label="Quantity"
          type="number"
          id="listitemwithcontrols-quantity"
          value={quantity.toString()}
          onChange={(e) => setQuantity(parseInt(e.target.value, 10) || 1)}
        />
        <FixaInputField
          label="Max Quantity"
          type="number"
          id="listitemwithcontrols-maxquantity"
          value={maxQuantity.toString()}
          onChange={(e) => setMaxQuantity(parseInt(e.target.value, 10) || 10)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(ListItemWithControlsDemo);
